// @noflow
import Component from './component';
import { connect } from 'react-redux';
import { getConfig } from '~/core/state/config/selectors';
import { getProducts } from '~/core/state/products/actions';
import { loadDevices } from '~/core/state/devices/actions';

const mapStateToProps = state => {
    const phoneNumber = getConfig(state, 'help:deviceOfflineTelephoneNumber');
    return {
        phoneNumber
    };
};

const mapDispatchToProps = dispatch => {
    return {
        refresh: () => {
            dispatch(loadDevices());
            dispatch(getProducts());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/wiring-error/index.js